import React, { useEffect } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useParams, useNavigate, Outlet} from 'react-router-dom'
import './Customer/CustomerContainer.css'
import customerActions from '../Actions/customerActions'
import quotationActions from '../Actions/quotationActions'
import commonActions from '../Actions/commonActions'
import Spinner from "../Components/Fundamentals/Spinner/Spinner";

function CustomerContainer({ commonActions, customerActions, customer, user, dataLoading, frontendSettings }) {
    const navigate = useNavigate();

    const { pathId } = useParams();

    useEffect(() => {
        const cleanupSurvicate = runSurvicate();

        return () => {
            cleanupSurvicate?.();
        }
    }, [frontendSettings?.survicateWorkspaceKey])

    useEffect(() => {
        return () => {
            commonActions.clearStoreSelected();
            customerActions.reset();
        }
    }, [])
    
    const navigateToMain = (id) => {
        navigate(location.pathname.replace(pathId, id));
    }

    const getCustomer = () => {
        if ((!customer || (customer?.pathId !== pathId)) && !dataLoading) {
            customerActions.getSelectedCustomer(pathId, navigateToMain);
        }
    }

    useEffect(() => {
        getCustomer();
    }, [pathId]);


    const runSurvicate = () => {
        const workspaceKey = frontendSettings?.survicateWorkspaceKey;
        if (!workspaceKey) return;

        (function(opts) {
            opts.traits = {
                id: user.email,
                customer_id: user.departmentId,
                function_name: 'SKY'
            };
        })(window._sva = window._sva || {});

        if (typeof window._sva?.invokeEvent === 'function') {
            window._sva.invokeEvent('CSAT_CustomerOverview');
            return;
        }

        const onReady = () => window._sva.invokeEvent('CSAT_CustomerOverview');
        window.addEventListener('SurvicateReady', onReady, { once: true });

        if (!document.getElementById('survicate-script')) {
            const script = document.createElement('script');
            script.id = 'survicate-script';
            script.src = `https://survey.survicate.com/workspaces/${workspaceKey}/web_surveys.js`;
            script.async = true;
            document.head.appendChild(script);
        }

        return () => window.removeEventListener('SurvicateReady', onReady);
    }

    if (!customer) {
        return <Spinner />;
    }

    return (<Outlet/>);
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        user: state.CommonReducer.user,
        dataLoading: state.CommonReducer.dataLoading.selectedCustomer,
        frontendSettings: state.CommonReducer.frontendSettings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        quotationActions: bindActionCreators(quotationActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerContainer);